import React, { useState } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import StandardCalculator from './components/calculators/StandardCalculator';
import MissedPaymentCalculator from './components/calculators/MissedPaymentCalculator';
import InterestAccrualCalculator from './components/calculators/InterestAccrualCalculator';
import RepaymentRestructuringCalculator from './components/calculators/RepaymentRestructuringCalculator';
import EarlyRepaymentCalculator from './components/calculators/EarlyRepaymentCalculator';
import ResultsPanel from './components/results/ResultsPanel';
import TabNavigation from './components/layout/TabNavigation';

export default function App() {
  const [activeTab, setActiveTab] = useState('standard');
  const [calculationResults, setCalculationResults] = useState(null);
  
  const tabs = [
    { id: 'standard', label: 'Standard Repayment' },
    { id: 'missed', label: 'Missed Payments' },
    { id: 'interest', label: 'Interest Accrual' },
    { id: 'restructure', label: 'Repayment Restructuring' },
    { id: 'early', label: 'Early Repayment' }
  ];

  const handleCalculationComplete = (results) => {
    console.log('Calculation results:', results);
    setCalculationResults(results);
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header />
      
      <main className="flex-grow container mx-auto p-4 md:p-6">
        <div className="max-w-5xl mx-auto">
          <TabNavigation 
            tabs={tabs} 
            activeTab={activeTab} 
            onTabChange={setActiveTab} 
          />
          
          <div className="mb-8">
            {activeTab === 'standard' && (
              <StandardCalculator onCalculate={handleCalculationComplete} />
            )}
            
            {activeTab === 'missed' && (
              <MissedPaymentCalculator onCalculate={handleCalculationComplete} />
            )}
            
            {activeTab === 'interest' && (
              <InterestAccrualCalculator onCalculate={handleCalculationComplete} />
            )}
            
            {activeTab === 'restructure' && (
              <RepaymentRestructuringCalculator onCalculate={handleCalculationComplete} />
            )}
            
            {activeTab === 'early' && (
              <EarlyRepaymentCalculator onCalculate={handleCalculationComplete} />
            )}
          </div>
          
          {calculationResults && (
            <ResultsPanel results={calculationResults} />
          )}
        </div>
      </main>
      
      <Footer />
    </div>
  );
}